/** What a loader reads from the search string, compared by value. */
export type ReadSearch = (searchParams: URLSearchParams) => unknown;

/** Whether moving between two search strings changes the inputs `readSearch` reads. */
export const searchInputsChanged = (readSearch: ReadSearch, from: string, to: string) =>
  from !== to &&
  JSON.stringify(readSearch(new URLSearchParams(from))) !==
    JSON.stringify(readSearch(new URLSearchParams(to)));
